import Vue from 'vue'
import Toast from './toast.vue'

const _Constructor = Vue.extend(Toast)

let instance

const show = (opts) => {
  const defaultOpts = { 
    message: '', 
    btnText: '', 
    icon: '',
    duration: 2000,
  }

  if (typeof opts === 'string') {
    defaultOpts.message = opts
  } else {
    Object.assign(defaultOpts, opts)
  }
  
  if (!instance) {
    instance = new _Constructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }

  instance.visible = true

  for (const key in defaultOpts) {
    if (Object.hasOwnProperty.call(defaultOpts, key)) {
      instance[key] = defaultOpts[key]
    }
  }

  setTimeout(() => {
    hide()
  }, defaultOpts.duration)
}

const hide = () => {
  if (instance) {
    instance.visible = false
  }
}

export default {
  install(Vue) {
    Vue.prototype.lyfToast = show
    Vue.prototype.lyfHideToast = hide
  }
}